namespace Matrix.Data {
    export namespace AccountModelTargetService {
        export const baseUrl = 'Data/AccountModelTarget';

        export declare function Create(request: Serenity.SaveRequest<AccountModelTargetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AccountModelTargetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function BatchUpdate(request: AccountModelTargetBatchUpdateRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function DeleteAll(request: AccountModelTargetDeleteAllRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AccountModelTargetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AccountModelTargetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function IsPendingApproval(request: AccountModelTargetIsPendingApprovalRequest, onSuccess?: (response: AccountModelTargetIsPendingApprovalResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ImportExcel(request: AccountModelTargetImportRequest, onSuccess?: (response: AccountModelTargetImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Data/AccountModelTarget/Create",
            Update = "Data/AccountModelTarget/Update",
            BatchUpdate = "Data/AccountModelTarget/BatchUpdate",
            Delete = "Data/AccountModelTarget/Delete",
            DeleteAll = "Data/AccountModelTarget/DeleteAll",
            Retrieve = "Data/AccountModelTarget/Retrieve",
            List = "Data/AccountModelTarget/List",
            IsPendingApproval = "Data/AccountModelTarget/IsPendingApproval",
            ImportExcel = "Data/AccountModelTarget/ImportExcel"
        }

        [
            'Create', 
            'Update', 
            'BatchUpdate', 
            'Delete', 
            'DeleteAll', 
            'Retrieve', 
            'List', 
            'IsPendingApproval', 
            'ImportExcel'
        ].forEach(x => {
            (<any>AccountModelTargetService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
